import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { KG_L_CONVERSION } from "../constants";

export default function truckDataReducer(state = initialState.truckData, action) {
    switch (action.type) {
        case types.TRUCK_HUB_CONNECTION:
            return {
                ...state,
                connected: action.status.connected,
                truckNumberPlate: action.status.truckNumberPlate || state.truckNumberPlate,
                // Any message from/about the truck is evidence of when it was last heard from.
                lastActivityAt: action.status.lastSeen || state.lastActivityAt,
                errorReason: action.status.connected ? null : state.errorReason,
            };
        case types.TRUCK_HUB_WEIGHT:
            return {
                ...state,
                truckNumberPlate: action.weight.truckNumberPlate || state.truckNumberPlate,
                lastActivityAt: action.weight.timestamp || state.lastActivityAt,
                weight: {
                    currentWeight: Math.ceil(action.weight.currentWeight * KG_L_CONVERSION),
                    currentRawWeight: action.weight.currentWeight,
                    connected: action.weight.scalesConnected,
                },
            };
        case types.TRUCK_HUB_RECEIPT:
            return {
                ...state,
                lastActivityAt: (action.receipt && action.receipt.receivedAt) || state.lastActivityAt,
                receipt: action.receipt ? {
                    pickupId: action.receipt.pickupId,
                    tankId: action.receipt.tankId,
                    deliveryTotal: action.receipt.deliveryTotal,
                    receiptId: action.receipt.receiptId,
                    receivedAt: action.receipt.receivedAt || null,
                } : null,
            };
        case types.TRUCK_HUB_CONTEXT:
            return {
                ...state,
                context: action.context || null,
            };
        case types.TRUCK_HUB_LOCATION:
            return {
                ...state,
                truckNumberPlate: action.location.truckNumberPlate || state.truckNumberPlate,
                lastActivityAt: action.location.timestamp || state.lastActivityAt,
                location: action.location ? {
                    latitude: action.location.latitude,
                    longitude: action.location.longitude,
                    truckNumberPlate: action.location.truckNumberPlate,
                    timestamp: action.location.timestamp || null,
                } : state.location,
            };
        default:
            return state;
    }
}
